module.exports = __webpack_public_path__ + "jtails-build/img/store_small@2.0ccacddf.jpg";